document.addEventListener('DOMContentLoaded', function() {
    const scroll_bar = document.querySelector('.scroll_bar');
    const site_credits_link = document.querySelector('a[href="#site-credits"]');

    if (site_credits_link && scroll_bar) {
        site_credits_link.addEventListener('click', (e) => {
            e.preventDefault(); // Prevenir navegación
            scroll_bar.classList.toggle('active');
        });
    }
});